export default "__VITE_ASSET__C_ixzK9q__"